import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { auctionsLabels } from "@/i18n/labels/auctionsLabels";
import { useLanguage } from "@/context/LanguageContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const pillTriggerClass =
  "native-scroll-chip shrink-0 rounded-full border border-border bg-background text-foreground text-[13px] font-medium whitespace-nowrap px-3 shadow-none data-[state=active]:border-primary data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-none";

export const AuctionsFilterTabs = () => {
  const { language } = useLanguage();
  const labels = auctionsLabels(language);
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="native-scroll-chips native-orders-tab-chips w-full max-w-full">
        <TabsList
          className={cn(
            "native-scroll-chips-track h-auto w-max max-w-none gap-2 bg-transparent p-0 shadow-none",
          )}
        >
          <TabsTrigger value="all" className={pillTriggerClass}>
            {labels.tabs.all}
          </TabsTrigger>
          <TabsTrigger value="auction" className={pillTriggerClass}>
            {labels.tabs.auctions}
          </TabsTrigger>
          <TabsTrigger value="direct" className={pillTriggerClass}>
            {labels.tabs.directPurchase}
          </TabsTrigger>
        </TabsList>
      </div>
    );
  }

  return (
    <TabsList
      className={`inline-flex items-center gap-1 backdrop-blur bg-secondary/50 text-xs sm:text-sm`}
    >
      <TabsTrigger
        value="all"
        className="text-sm sm:text-sm whitespace-nowrap py-2 sm:py-2 px-3 sm:px-3 data-[state=active]:bg-accent"
      >
        {labels.tabs.all}
      </TabsTrigger>
      <TabsTrigger
        value="auction"
        className="text-sm sm:text-sm whitespace-nowrap py-2 sm:py-2 px-3 sm:px-3 data-[state=active]:bg-accent"
      >
        {labels.tabs.auctions}
      </TabsTrigger>
      <TabsTrigger
        value="direct"
        className="text-sm sm:text-sm whitespace-nowrap py-2 sm:py-2 px-3 sm:px-3 data-[state=active]:bg-accent"
      >
        {labels.tabs.directPurchase}
      </TabsTrigger>
    </TabsList>
  );
};
